import { Component } from '@angular/core'
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouterOutlet, RouterLink } from '@angular/router'
import { NavbarComponent } from './navbar/navbar.component'
import { AdminNavbarComponent } from './admin-navbar/admin-navbar.component'
import { CartDrawerComponent } from './shared/cart-drawer/cart-drawer.component'
import { CartService } from './services/cart.service'
import { ThemeService } from './services/theme.service'
import { LoaderComponent } from './shared/loader/loader.component'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, AdminNavbarComponent, CartDrawerComponent, RouterLink, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'isl-app'
  isAdminRoute = false
  isRouteLoading = true
  pendingRoute = ''
  private isFirstLoad = true

  constructor(
    private router: Router,
    private themeService: ThemeService,
    public cartService: CartService
  ) {
    this.themeService.initTheme()

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.isFirstLoad) this.isRouteLoading = true
      } else if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects || event.url
        const path = url.split('?')[0].split('#')[0]
        const segments = path.split('/').filter(Boolean)
        this.isAdminRoute = segments[0] === 'admin' || segments[0] === 'super-admin'
        this.isRouteLoading = false
        this.isFirstLoad = false
        this.pendingRoute = ''
      } else if (event instanceof NavigationCancel || event instanceof NavigationError) {
        this.isRouteLoading = false
        this.isFirstLoad = false
        this.pendingRoute = ''
      }
    })
  }

  selectNav(route: string): void {
    this.pendingRoute = route
  }

  isNavActive(route: string): boolean {
    if (this.pendingRoute) return this.pendingRoute === route
    if (route === '/') return this.router.url.split('?')[0] === '/'
    return this.router.url.startsWith(route)
  }
}
